var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-wrap"},[_c('div',{staticClass:"el-tree-1"},[_c('el-tree',{ref:"tree",attrs:{"data":_vm.data,"empty-text":_vm.emptyText,"props":_vm.defaultProps,"lazy":true,"load":_vm.getData},on:{"node-click":_vm.nodeClick}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75d519be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Oa/department-tree.vue
// module id = null
// module chunks = 